import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CargoDropDown } from "../../../../../common/domain/models/cargo_dropdown";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { TreinamentoDropDown } from "../../../../rh/domain/models/treinamento_dropdown";

type State = {
  IdFuncionarioTerc: number;
  DocumentosPesquisa: number;
  CargoPesquisa: number;
  AvaliacoesPesquisa: number;
  StatusPesquisa: number;
  ContratoPesquisa: number;
  FornecedorPesquisa: number;
  NomePesquisa: string;
  centroDeCusto: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
  treinamentoLista: TreinamentoDropDown[] | null;
};

type Actions = {
  setIdFuncionarioTerc: SetFunction<number>;
  setDocumentosPesquisa: SetFunction<number>;
  setCargoPesquisa: SetFunction<number>;
  setAvaliacoesPesquisa: SetFunction<number>;
  setStatusPesquisa: SetFunction<number>;
  setContratoPesquisa: SetFunction<number>;
  setFornecedorPesquisa: SetFunction<number>;
  setNomePesquisa: SetFunction<string>;
  setTreinamentoLista: SetFunction<TreinamentoDropDown[]>;
  setCentroDeCusto: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  IdFuncionarioTerc: 0,
  FornecedorPesquisa: 0,
  ContratoPesquisa: 0,
  StatusPesquisa: 1,
  centroDeCusto: [],
  centroDeCustoLista: undefined,
  AvaliacoesPesquisa: 4,
  CargoPesquisa: 0,
  DocumentosPesquisa: 2,
  NomePesquisa: "",
  treinamentoLista: null,
};

export const useFuncionariosTercerizacaoFilters = create<State & Actions>((set) => ({
  ...initialFiltersValues,
  setTreinamentoLista: (vfn) => SetFunctionImpl(set, "treinamentoLista", vfn),
  setIdFuncionarioTerc: (vfn) => SetFunctionImpl(set, 'IdFuncionarioTerc', vfn),
  setAvaliacoesPesquisa: (vfn) => SetFunctionImpl(set, 'AvaliacoesPesquisa', vfn),
  setNomePesquisa: (vfn) => SetFunctionImpl(set, 'NomePesquisa', vfn),
  setDocumentosPesquisa: (vfn) => SetFunctionImpl(set, 'DocumentosPesquisa', vfn),
  setCargoPesquisa: (vfn) => SetFunctionImpl(set, 'CargoPesquisa', vfn),
  setContratoPesquisa: (vfn) => SetFunctionImpl(set, 'ContratoPesquisa', vfn),
  setFornecedorPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorPesquisa', vfn),
  setStatusPesquisa: (vfn) => SetFunctionImpl(set, 'StatusPesquisa', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),


  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));